export default __webpack_public_path__ + "static/media/plain-sticker-of.57c3af47.png";